// src/i18n/en/dashboard.js
const dashboard = {
    title: 'Dashboard',
    subtitle: 'Locker Management System',
    welcome: 'Welcome, %{name}',
    
    // Navigation and Tabs
    overview: 'Overview',
    performance: 'Performance',
    efficiency: 'Efficiency',
    
    // Period filters
    period: 'Period',
    today: 'Today',
    last_7_days: 'Last 7 Days',
    last_30_days: 'Last 30 Days',
    
    // Hotel selection
    select_hotel: 'Select Hotel',
    no_hotel_selected: 'Please select a hotel to view dashboard',
    
    // Dashboard Summary
    available_lockers: 'Available Lockers',
    today_assignments: "Today's Assignments",
    expired_active: 'Expired Active',
    hmi_status: 'HMI Status',
    of: 'of',
    total: 'total',
    pending_checkins: 'pending check-ins',
    require_attention: 'Require attention',
    online_devices: 'Online devices',
    zone_availability: 'Zone Availability',
    recent_assignments: 'Recent Assignments',
    
    // Key Metrics
    key_metrics: 'Key Metrics',
    occupancy_rate: 'Occupancy Rate',
    conversion_rate: 'Conversion Rate',
    avg_usage_hours: 'Avg Usage Time',
    total_issues: 'Total Issues',
    
    // Charts
    usage_trends: 'Usage Trends',
    assignments_created: 'Created',
    assignments_activated: 'Activated',
    accesses: 'Accesses',
    zone_performance: 'Zone Performance',
    occupancy: 'Occupancy %',
    efficiency_percent: 'Efficiency %',
    pending: 'Pending',
    
    // Assignment Efficiency
    assignment_efficiency: 'Assignment Efficiency',
    avg_time_to_use: 'Avg Time to First Use',
    never_used: 'Never Used',
    most_requested_types: 'Most Requested Locker Types',
    peak_demand_times: 'Peak Demand Times',
    
    // Resources translations for dashboard components
    current_occupancy: 'Current Occupancy',
    total_assignments: 'Total Assignments',
    active_count: 'Active Count',
    avg_usage_time: 'Average Usage Time',
    per_assignment: 'Per Assignment',
    pending_to_active: 'Pending to Active',
    issues: 'Issues',
    avg_time_first_use: 'Average Time to First Use',
    never_used_assignments: 'Never Used Assignments',
    auto_archived_expired: 'Auto Archived Expired',
    average_availability: 'Average Availability',
    weekly_usage_trend: 'Weekly Usage Trend',
    occupancy_percent: 'Occupancy Percent',
    assignments_label: 'Assignments Label',
    locker_status: 'Locker Status',
    system_health: 'System Health',
    hmi_devices: 'HMI Devices',
    devices_online: 'Devices Online',
    blocked_lockers: 'Blocked Lockers',
    lockers_awaiting_clearance: 'Lockers Awaiting Clearance',
    expired_assignments: 'Expired Assignments',
    assignments_past_due: 'Assignments Past Due',
    
    // System Info View translations
    system_information: 'System Information',
    loading_system_data: 'Loading system data...',
    failed_load_system_info: 'Failed to load system information',
    error_loading_system_info: 'Error loading system information',
    error_loading_background_jobs: 'Error loading background jobs',
    job_triggered_successfully: 'Job triggered successfully',
    error_triggering_job: 'Error triggering job',
    refresh_jobs: 'Refresh Jobs',
    trigger_job_now: 'Trigger Job Now',
    no_background_jobs_found: 'No background jobs found',
    
    // Application section
    application: 'Application',
    version: 'Version',
    environment: 'Environment',
    uptime: 'Uptime',
    processors: 'Processors',
    machine: 'Machine',
    
    // Database section  
    database: 'Database',
    status: 'Status',
    size: 'Size',
    provider: 'Provider',
    pending_migrations: 'Pending Migrations',
    connected: 'Connected',
    
    // Background Jobs section
    background_jobs: 'Background Jobs',
    job_name: 'Job Name',
    queue: 'Queue',
    schedule: 'Schedule',
    last_execution: 'Last Execution',
    next_execution: 'Next Execution',
    actions: 'Actions',
    success: 'Success',
    succeeded: 'Succeeded',
    failed: 'Failed',
    running: 'Running',
    tabs: {
        overview: 'Overview',
        operational: 'Operational',
        analytics: 'Analytics',
        reports: 'Reports',
    },
    stats: {
        title: 'Quick Stats',
        total_lockers: 'Total Lockers',
        available_lockers: 'Available',
        occupied_lockers: 'Occupied',
        maintenance_lockers: 'Under Maintenance',
        occupancy_rate: 'Occupancy Rate',
        active_assignments: 'Active Assignments',
        today_checkins: 'Check-ins Today',
        today_checkouts: 'Check-outs Today',
        alerts: 'Active Alerts',
    },
    zones: {
        title: 'Availability by Zone',
        total: 'Total',
        available: 'Available',
        occupied: 'Occupied',
        occupancy: 'Occupancy',
        no_zones: 'No zones configured',
    },
    recent: {
        title: 'Recent Activity',
        assignments: 'Recent Assignments',
        releases: 'Recent Releases',
        maintenance: 'Recent Maintenance',
        no_activity: 'No recent activity',
        view_all: 'View all',
    },
    charts: {
        usage_trends: 'Usage Trends',
        occupancy_chart: 'Occupancy by Hour',
        zone_performance: 'Zone Performance',
        locker_types: 'Distribution by Type',
        weekly_summary: 'Weekly Summary',
        period: {
            today: 'Today',
            week: '7 days',
            month: '30 days',
            quarter: '90 days',
        },
    },
    quick_actions: {
        title: 'Quick Actions',
        new_assignment: 'New Assignment',
        find_locker: 'Find Locker',
        bulk_release: 'Bulk Release',
        maintenance_mode: 'Maintenance Mode',
        generate_report: 'Generate Report',
        scan_tag: 'Scan Tag',
    },
    alerts: {
        title: 'Alerts and Notifications',
        high_occupancy: 'High occupancy in %{zone}',
        maintenance_required: 'Maintenance required',
        low_availability: 'Low locker availability',
        system_alert: 'System alert',
        no_alerts: 'No active alerts',
        view_all: 'View all alerts',
    },
    efficiency_metrics: {
        title: 'Efficiency Metrics',
        avg_assignment_time: 'Average Assignment Time',
        avg_occupancy: 'Average Occupancy',
        turnover_rate: 'Turnover Rate',
        utilization_rate: 'Utilization Rate',
        peak_hours: 'Peak Hours',
        maintenance_rate: 'Maintenance Rate',
    },
    filters: {
        hotel: 'Hotel',
        all_hotels: 'All hotels',
        zone: 'Zone',
        all_zones: 'All zones',
        period: 'Period',
        apply: 'Apply',
        reset: 'Reset',
    },
    messages: {
        loading: 'Loading dashboard...',
        error: 'Error loading data',
        refresh_success: 'Data updated',
        no_data: 'No data available',
        select_hotel: 'Select a hotel',
        access_denied: 'You do not have permission to view the dashboard',
    },
};

export default dashboard;
